import {MINUTES_TEXT, SECONDS_TEXT} from './constants';
import Utils from './Utils';

export const errorTimeMessage = (time, action = 'ввода кода') => {
    const finishPhrase = formatBlockDuration(time);

    const message = `Вы&nbsp;превысили лимит на&nbsp;количество попыток ${action}. Ваш аккаунт заблокирован на ${finishPhrase}.`;

    return message;
};

export const formatBlockDuration = (seconds) => {
    const totalSeconds = Math.max(0, Math.round(Number(seconds) || 0));
    const minutes = Math.floor(totalSeconds / 60);
    const restSeconds = totalSeconds % 60;

    if (!minutes) {
        return `${totalSeconds} ${Utils.pluralWord(totalSeconds, SECONDS_TEXT)}`;
    }

    const minutesPhrase = `${minutes} ${Utils.pluralWord(minutes, MINUTES_TEXT)}`;

    if (!restSeconds) {
        return minutesPhrase;
    }

    return `${minutesPhrase} ${restSeconds} ${Utils.pluralWord(restSeconds, SECONDS_TEXT)}`;
};